module.exports = __webpack_public_path__ + "static/media/photo-rg-front.f1c7933b.jpg";